import './ui.css';

export function Spinner({ center = false }: { center?: boolean }) {
  const spinner = <span className="ui-spinner" role="status" aria-label="Loading" />;
  return center ? <div className="ui-spinner-center">{spinner}</div> : spinner;
}
